import React from "react"

export function Analytics(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0" y="8" width="3" height="8" fill="currentColor" />
      <rect x="4.5" y="4" width="3" height="12" fill="currentColor" />
      <rect x="9" y="0" width="3" height="16" fill="currentColor" />
      <rect x="13.5" y="6" width="2.5" height="10" fill="currentColor" />
    </svg>
  )
}
